define("shared/utils/object-methods/object-snake-to-camel", ["exports", "lodash", "shared/utils/string-formatters/snake-to-camel"], function (_exports, _lodash, _snakeToCamel) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"lodash",0,"shared/utils/string-formatters/snake-to-camel"eaimeta@70e063a35619d71f
  /**
   * Calls snakeToCamel on all keys in given object
   */
  const objectSnakeToCamel = data => {
    if (Array.isArray(data)) {
      return data.map(item => objectSnakeToCamel(item));
    } else if ((0, _lodash.isObject)(data)) {
      return Object.entries(data).reduce((acc, _ref) => {
        let [key, value] = _ref;
        acc[(0, _snakeToCamel.default)(key)] = objectSnakeToCamel(value);
        return acc;
      }, {});
    }
    return data;
  };
  var _default = _exports.default = objectSnakeToCamel;
});